<script>
	const _ = require('underscore');

	const model = require('model/model');
	const accountSettingsUtilities = require('utilities/accountSettingsUtilities');
	const accountUtilities = require('utilities/accountUtilities');
	const updateAccountSetting = accountSettingsUtilities.update;
	const { assetUrl } = require('utilities/urlUtilities');

	const updateSchoolRemoteness = _.debounce(function (params, vm) {
		vm.submitAndDismiss();
		accountUtilities.update(params);
	}, 3000);

	export default {
		components: {
			'toggle-buttons': require('components/toggle-buttons.vue').default
		},
		data() {
			return {
				schoolRemoteness: null
			};
		},
		computed: {
			schoolRemotenessOptions() {
				return [
					{ value: 'p', label: 'In-person' },
					{ value: 'r', label: 'Remote' },
					{ value: 'h', label: 'Hybrid' }
				].map(o => {
					return Object.assign({}, o, {
						selected: this.schoolRemoteness === o.value
					});
				});
			},
			barLoaderSrc() {
				return assetUrl('/assets/dist/images/notification-bar-loader.gif');
			}
		},
		methods: {
			clickSchoolRemotenessOption(option) {
				this.schoolRemoteness = option.value;
				updateSchoolRemoteness(
					{
						schoolRemoteness: this.schoolRemoteness
					},
					this
				);
			},
			submitAndDismiss() {
				updateAccountSetting(accountSettingsUtilities.settings.REMOTE_IN_PERSON_2020_DISMISS, true);
				model.set('submittedSchoolRemotenessBanner', Date.now());
				model.set('bannerNotification', accountSettingsUtilities.CAMPAIGN_BANNERS.pleaseReviewSchool);
			}
		}
	};
</script>
<template>
	<div class="remote-in-person-campaign-component text-centered">
		Help us support your teaching! Currently, my school is:
		<toggle-buttons
			button-flags="-outline -small"
			@click-item="clickSchoolRemotenessOption"
			:options="schoolRemotenessOptions"></toggle-buttons>
		<img
			v-if="schoolRemoteness"
			class="loader"
			:src="barLoaderSrc" />
	</div>
</template>
<style lang="scss">
	.remote-in-person-campaign-component {
		img.loader {
			// absolute position the image where it lands (no top, no left specified) so that
			// it doesn't affect centering of the text and push everything left when it appears
			position: absolute;
			padding: 0.5rem 0 0 0.5rem;
		}
	}
</style>
